<template>
  <div class="work-process-form">
    <CForm id="workProcessForm" @submit.prevent="handleSubmit">
      <CInput
          v-model="form.name"
          label="Ime procesa"
          name="name"
          required
      />

      <div class="form-group">
        <label for="vehile-model">Izberi model</label>
        <v-select
            v-model="form.vehicle_model_id"
            :options="vehicleModels"
            label="name"
            class="text-muted"
            :reduce="model => model.id"
            @search="onSearch"
            :filterable="false"
            :placeholder="searchPlaceholder"
            id="vehile-model"
            required
        >
          <!-- Option in dropdown -->
          <template #option="{ name, vehicle_brand }">
            {{ name }} ({{ vehicle_brand ? vehicle_brand.title : '' }})
          </template>

          <!-- Selected value -->
          <template #selected-option="option">
            {{ getSelectedLabel(option) }}
          </template>
        </v-select>
      </div>
      <CFormGroup>
        <CButton type="submit" color="primary">Save</CButton>
        <CButton type="button" color="secondary" @click="$emit('cancel')">Cancel</CButton>
      </CFormGroup>
    </CForm>
    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'WorkProcessForm',

  props: {
    workProcess: {
      type: Object,
      default: () => ({})
    },
    showAddModal: Boolean
  },

  data() {
    return {
      form: {
        name: '',
        vehicle_model_id: null,
        id : null,
      },
      vehicleModels: [],
      searchPlaceholder: 'Vnesi vsaj tri črke za iskanje',
      selectedModel: null  // Store the full selected model
    }
  },

  watch: {
    workProcess: {
      handler(workprocess) {
        this.form = {
          name: workprocess?.name || '',
          vehicle_model_id: workprocess?.vehicle_model_id || null,
          id: workprocess?.id || null
        }

        if (workprocess?.vehicle_model) {
          this.vehicleModels = [workprocess.vehicle_model]
          this.selectedModel = workprocess.vehicle_model
        }
      },
      immediate: true
    },

    // Watch for changes in vehicle_model_id
    'form.vehicle_model_id'(newId) {
      // Update selectedModel when ID changes
      this.selectedModel = this.vehicleModels.find(model => model.id === newId) || null
    },

    showAddModal: {
      handler(newVal) {
        if (!newVal) {
          this.form = {
            name: '',
            vehicle_model_id: null,
            id: null
          }
        }
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions('workProcesses', ['fetchVehicleModels']),

    getSelectedLabel(option) {
      // If we have a selectedModel, use that
      if (this.selectedModel) {
        return `${this.selectedModel.name} (${this.selectedModel?.vehicle_brand?.title})`
      }

      // If we have the full option object
      if (option && option.name && option.vehicle_brand) {
        return `${option.name} (${option.vehicle_brand.title})`
      }

      // Fallback
      return 'Izberi model'
    },

    onSearch(search) {
      if (!search || search.length < 3) {
        if (!this.form.vehicle_model_id) {
          this.vehicleModels = []
        }
        this.searchPlaceholder = 'Vnesi vsaj 3 črke'
        return
      }

      this.searchPlaceholder = 'Iskanje...'
      this.fetchVehicleModels(search)
          .then(vehicles => {
            this.vehicleModels = vehicles
            this.searchPlaceholder = vehicles.length
                ? 'Izberi opcijo'
                : 'Ni rezultatov'
          })
          .catch(() => {
            this.$refs.toastr.e('Error', 'Napaka pri iskanju modelov')
            this.searchPlaceholder = 'Napaka pri iskanju'
            this.vehicleModels = []
          })
    },

    handleSubmit(event) {
      if (this.form.name && this.form.vehicle_model_id) {
        this.$emit('submit', {...this.form})
      } else {

        this.$refs.toastr.e('Error', 'Manjkajoči podatki na formi!')
      }
    }
  }
}
</script>
